<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">{{
          isAT ? "Iniciativa" : isGov ? "Fases" : "Solução"
        }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-group-solution-by-city-combobox
              :filter="edit ? payload : municipioGrupoSolucao"
              :onlyEnable="true"
              v-if="(filter && !filter.municipioGrupoSolucao) || edit"
              :loadfirst="true"
            ></app-group-solution-by-city-combobox>

            <v-text-field
              v-model="filter.municipioGrupoSolucao.nome"
              v-if="filter && filter.municipioGrupoSolucao && !edit"
              :label="`${
                isAT
                  ? 'Grupo de Iniciativa'
                  : isGov
                  ? 'Grupo de Fases'
                  : 'Grupo de Solução'
              }`"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin || (config.verCustoPreco && groupsConfig.verCustoPreco)
          "
        >
          <v-col>
            <v-currency-field
              label="Custo"
              :prefix="currency"
              filled
              v-model="payload.custo"
            />
          </v-col>
          <v-col>
            <v-currency-field
              label="Preço"
              :prefix="currency"
              filled
              v-model="payload.preco"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-consultant-combobox
              :filter="payload"
              :isMultiple="
                isFullAdmin ||
                (config.podeSelecionarMaisDeUmUsuarioSolucao &&
                  groupsConfig.podeSelecionarMaisDeUmUsuarioSolucao)
              "
            ></app-consultant-combobox>
          </v-col>
        </v-row>
        <v-row
          v-if="
            Array.isArray(payload.usuarioId)
              ? payload.usuarioId.length > 0
              : payload.usuarioId
          "
        >
          <v-col
            v-if="
              isFullAdmin ||
              (config.exibeContrato && groupsConfig.exibeContrato)
            "
          >
            <v-text-field
              v-model="payload.contrato"
              :label="`Contrato`"
            ></v-text-field>
          </v-col>
          <v-col
            v-if="
              isFullAdmin ||
              (config.exibeComunicacaoInterna &&
                groupsConfig.exibeComunicacaoInterna)
            "
          >
            <v-text-field
              v-model="payload.comunicacaoInterna"
              :label="`Comunicação Interna (CI)`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verDataContratoSolucao &&
              groupsConfig.verDataContratoSolucao)
          "
        >
          <v-col>
            <v-text-field
              v-model="payload.inicioContrato"
              v-mascara="'##/##/####'"
              label="Início do Contrato"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="payload.fimContrato"
              v-mascara="'##/##/####'"
              label="Término do Contrato"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-if="
              isFullAdmin ||
              (config.verStatusSolucao && groupsConfig.verStatusSolucao)
            "
          >
            <status-solucao-combobox
              :filter="payload"
            ></status-solucao-combobox>
          </v-col>
          <v-col
            v-if="
              isFullAdmin ||
              (config.verPortifolioSolucao && groupsConfig.verPortifolioSolucao)
            "
          >
            <v-checkbox
              v-model="payload.portifolio"
              label="Portifólio"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin ||
            (config.exibirSecretaria && groupsConfig.exibirSecretaria)
          "
        >
          <v-col>
            <combobox-secretaria
              :filter="payload"
              :municipioId="payload.municipioId"
            ></combobox-secretaria>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verTipoSolucao && groupsConfig.verTipoSolucao)
          "
        >
          <v-col>
            <combobox-tipo-solucao :filter="payload"></combobox-tipo-solucao>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-radio-group v-model="payload.monitoramento">
              <v-radio
                v-for="monitoramento in tiposMonitoramento"
                :label="monitoramento.label"
                :value="monitoramento.value"
                :key="monitoramento.value"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="payload.monitoramento === 1">
          <v-col>
            <v-text-field
              v-model="payload.maxHoras"
              label="Máximo de horas"
              placeholder="12"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataInicioString"
              v-mask="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataTerminoString"
              v-mask="'##/##/####'"
              label="Data de Término"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de visitas presenciais"
              name="numero-visitas-presenciais"
              type="number"
              required
              v-model="payload.visitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de visitas presenciais"
              name="horas-previstas-visitas-presenciais"
              type="number"
              required
              v-model="payload.horasPrevistasVisitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de trabalhos de escritório"
              name="numero-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.trabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de trabalhos de escritório"
              name="horas-previstas-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.horasPrevistasTrabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="payload.naoComputaHoras"
              label="Não Computa Horas?"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from "@/modules/city/API/CitySolutionAPI";
import AppGroupSolutionByCityCombobox from "@/modules/city/components/terms-reference/groups-solution/ComboboxByCity.vue";
import { AppConsultantCombobox } from "@/modules/user";
import { mapActions, mapGetters } from "vuex";
import { usuarioPermissaoMunicipioSolucaoApi } from "@/apis";
import ComboboxSecretaria from "../../../city/components/secretaria/ComboboxSecretaria.vue";
import ComboboxTipoSolucao from "@/modules/tipoSolucao/components/Combobox";
import StatusSolucaoCombobox from "@/components/combobox/solucoes/StatusSolucaoCombobox.vue";
import moment from "moment";

export default {
  name: "AppModalInsertSolution",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { municipioGrupoSolucao: {} },
    municipioSolucao: {},
    allSolutions: [],
  },
  components: {
    AppGroupSolutionByCityCombobox,
    AppConsultantCombobox,
    ComboboxSecretaria,
    ComboboxTipoSolucao,
    StatusSolucaoCombobox,
  },
  computed: {
    ...mapGetters(["user", "isAT", "isFullAdmin", "isGov"]),
  },
  data() {
    return {
      payload: {
        monitoramento: 1,
        municipioId: this.$route.params.id,
        municipioGrupoSolucao: {},
        usuarioId: [],
        usuariosId: [],
        status: null,
      },
      municipioGrupoSolucao: {
        municipioGrupoSolucao: {},
      },
      currency: "R$",
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      dialog: false,
      loadfirst: false,
      tiposMonitoramento: [
        { label: "Tarefas", value: 1 },
        { label: "Visitas", value: 2 },
      ],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    close() {
      if (this.edit !== true) {
        this.payload = {
          monitoramento: 1,
          municipioId: this.$route.params.id,
          municipioGrupoSolucao: this.municipioGrupoSolucao,
        };
      } else {
        this.payload = {
          ...this.object,
          inicioContrato: this.object.inicioContrato
            ? moment(this.object.inicioContrato, "DD/MM/YYYY")
            : null,
          fimContrato: this.object.fimContrato
            ? moment(this.object.fimContrato, "DD/MM/YYYY")
            : null,
          monitoramento:
            this.object.monitoramento > 0 ? this.object.monitoramento : 1,
        };

        this.municipioGrupoSolucao = this.object.municipioGrupoSolucao;
      }
      this.dialog = false;
    },
    onConfirm() {
      if (
        !this.municipioGrupoSolucao &&
        !this.payload.municipioGrupoSolucao &&
        !this.payload.municipioGrupoSolucao.municipioGrupoSolucaoId
      ) {
        this.$notification.error(
          `O preenchimento de um ${
            this.isAT
              ? "Grupo de Iniciativa"
              : this.isGov
              ? "Grupo de Fases"
              : "Grupo de Solução"
          } é obrigatório.`
        );
      } else {
        this.setLoading(true);
        let usuarioWithou0 = this.payload.usuarioId;

        if (Array.isArray(usuarioWithou0)) {
          usuarioWithou0 = usuarioWithou0.filter((user) => user > 0);
        }

        let usuarioId = usuarioWithou0[0] || usuarioWithou0;
        let usuariosId = usuarioWithou0;

        if (typeof usuarioId !== "number") {
          usuarioId = usuarioId.usuarioId;
        }

        if (!Array.isArray(usuariosId)) {
          usuariosId = [usuarioId];
        }

        if (usuariosId.length > 0) {
          usuariosId = usuariosId.map((element) => {
            if (typeof element !== "number") {
              return element.usuarioId;
            }

            return element;
          });
        }

        const valores = {
          ...this.payload,
          usuariosId: usuariosId,
          usuarioId: usuarioId,
          municipioGrupoSolucaoId:
            this.payload.municipioGrupoSolucao.municipioGrupoSolucaoId ||
            (this.municipioGrupoSolucao &&
              this.municipioGrupoSolucao.municipioGrupoSolucaoId),
          municipioGrupoSolucao: null,
          inicioContrato: this.payload.inicioContrato
            ? moment(this.payload.inicioContrato, "DD/MM/YYYY")
            : null,
          fimContrato: this.payload.fimContrato
            ? moment(this.payload.fimContrato, "DD/MM/YYYY")
            : null,
        };
        if (this.edit === true) {
          citySolutionAPI
            .update(valores)
            .then(() => {
              this.dialog = false;
              this.setLoading(false);
              this.payload = { ...this.object };

              this.$emit("onSave");
            })
            .catch((resp) => {
              this.setLoading(false);
              console.log("Erro ao editar solução ", resp);

              this.$notification.error(
                `"Erro ao atualizar ${
                  this.isAT ? "iniciativa" : this.isGov ? "fases" : "solução"
                }`
              );
            });
        } else {
          citySolutionAPI
            .create(valores)
            .then(() => {
              this.dialog = false;
              this.setLoading(false);
              this.payload = {
                monitoramento: 1,
                municipioId: this.$route.params.id,
                municipioGrupoSolucao: this.municipioGrupoSolucao,
              };

              this.$emit("onSave");
            })
            .catch((resp) => {
              this.setLoading(false);
              console.log("Erro ao criar solução ", resp);
              this.$notification.error(
                `Erro ao criar ${
                  this.isAT ? "iniciativa" : this.isGov ? "fases" : "solução"
                }`
              );
            });
        }
      }
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.object && this.edit === true) {
          this.payload = {
            ...this.object,
            inicioContrato: this.object.inicioContrato
              ? moment(this.object.inicioContrato).format("DD/MM/YYYY")
              : null,
            fimContrato: this.object.fimContrato
              ? moment(this.object.fimContrato).format("DD/MM/YYYY")
              : null,
            monitoramento:
              this.object.monitoramento > 0 ? this.object.monitoramento : 1,
          };

          usuarioPermissaoMunicipioSolucaoApi
            .list(this.payload.municipioId, this.payload.municipioSolucaoId)
            .then(({ data: usuarios }) => {
              if (
                this.isFullAdmin ||
                (this.config.podeSelecionarMaisDeUmUsuarioSolucao &&
                  this.groupsConfig.podeSelecionarMaisDeUmUsuarioSolucao)
              ) {
                if (usuarios.length > 0) {
                  let users = usuarios.map((element) => {
                    if (typeof element !== "number") {
                      return element.usuarioId;
                    }

                    return element;
                  });

                  this.payload.usuarioId = users || this.payload.usuarioId;
                } else {
                  var newValue = this.payload.usuarioId;
                  this.payload.usuarioId = [];
                  this.payload.usuarioId.push(newValue);
                }
              } else if (
                !this.isFullAdmin &&
                this.config.podeSelecionarMaisDeUmUsuarioSolucao &&
                this.groupsConfig.podeSelecionarMaisDeUmUsuarioSolucao
              ) {
                var newValue = this.payload.usuarioId;
                this.payload.usuarioId = [];
                this.payload.usuarioId.push(newValue);
              }

              this.loadfirst = true;
            });
        }
      }
    },
    "filter.municipioGrupoSolucao": {
      handler(newValue) {
        if (this.filter.municipioGrupoSolucao) {
          this.municipioGrupoSolucao = newValue;
        }
      },
      deep: true,
    },
    object(newValue) {
      this.payload = newValue;
      this.municipioGrupoSolucao = newValue.municipioGrupoSolucao;
    },
  },
  mounted() {
    this.municipioGrupoSolucao = this.filter.municipioGrupoSolucao;

    if (this.isAT || this.isGov) {
      this.tiposMonitoramento = [
        { label: "Atividades", value: 1 },
        { label: "Visitas", value: 2 },
      ];
    }
  },
};
</script>
